module.exports = __webpack_public_path__ + "img/Innovazioni Griglia 1.9c5714dc.webp";